import { GrupoContacto } from "@shared/enums/GrupoContacto";

export class Contacto {
    id:string;
    nombre:string;
    numero:string;
    email:string;
    gruposAeroplanta: GruposAeroplanta[];
}

interface GruposAeroplanta {
    codigoAeroplanta: string;
    gruposContacto: GrupoContacto[];
}